<template>
  <div>
    <div v-for="option in question.options" v-bind:key="option.id" :id="question.id">
      <label>
        <input  type="checkbox"
                :id="question.answer.id"
                class="checkbox"
                :checked="answer.includes(option.choice)"
                :value="option.choice"
                :categoryId="categoryId"
                @change="updateValue(option.choice)">
      {{option.choice}}</label>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    question: Object,
    categoryId: Number
  },
  data(){
    return {
      answer: []
    }
  },
  mounted(){
    this.answer = this.$props.question.answer.value
  },
  methods: {
    updateValue(choice) {
      var i = this.answer.indexOf(choice)
      if ( i === -1 ) {
        this.answer.push(choice)
      } else {
        this.answer.splice(i, 1)
      }
    }
  }
}
</script>

<style>

</style>
